
export default {
    accessRuleList: [],
    currentAccessobject:{}
};
